import {Component, OnInit, ViewChild} from '@angular/core';
import {SharedResource} from "../../../model/shared-resource";
import {SharedService} from "../../../services/shared.service";
import {EntityEmail} from "../../../model/entity-email";
import {ActivatedRoute, Router} from "@angular/router";
import {CommonMessagesService} from "../../../services/common-messages.service";
import {EntityEmailFilters} from "../../../model/filters/entity-email-filters";
import {ResolvedResource} from "../../../model/resolved-resource";
import {ShareData} from "../../../model/shared-data";

@Component({
  selector: 'app-shared-resources-details',
  templateUrl: './shared-resources-details.component.html',
  styleUrls: ['./shared-resources-details.component.scss']
})
export class SharedResourcesDetailsComponent implements OnInit {

  @ViewChild("table")
  public table: any;

  public sharedResource: ResolvedResource;
  public totalSharedEmails: number;
  public loadingSharedResource: boolean;
  public sharedWithEmails: ShareData[];

  public rows = 10;
  public first = 0;
  public selected: ShareData[] = [];

  public currentFilters: EntityEmailFilters;
  public filtersVisible: boolean;

  public sharedResources: Array<SharedResource> = [];
  public showDialog: boolean = false;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private commonMessagesService: CommonMessagesService,
              private sharedService: SharedService) {
    this.currentFilters = new EntityEmailFilters();
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => this.loadSharedResource(params.uuid));
  }

  private loadSharedResource(sharedResourceUuid: string): void {
    this.loadingSharedResource = true;
    this.selected = [];
    this.sharedWithEmails = new Array(this.rows);
    this.sharedService.getSharedResource(sharedResourceUuid).subscribe(response => {
      this.sharedResource = response.resolvedResource;
      this.sharedWithEmails = this.sharedResource.resolvedShareData;
      this.totalSharedEmails = this.sharedWithEmails.length;
      this.loadingSharedResource = false;
    }, error => {
      if (error.status === 404) {
        this.router.navigate(['/not-found']);
      }
    });
  }

  showSharedDialog(): void {
    this.sharedResources = [new SharedResource(this.sharedResource.resourceType, this.sharedResource.name, this.sharedResource.sharedResourceUuid,
      this.sharedResource.tenantOwnerUuid, this.sharedResource.organizationOwnerUuid)];
    this.showDialog = true;
  }

  sharedResourceSuccess(): void {
    this.resetFilters();
    this.loadSharedResource(this.sharedResource.sharedResourceUuid);
  }

  confirmAndStopSharing(entityEmail: EntityEmail): void {
    this.commonMessagesService.showStopSharingRequestConfirmation(() => {
      this.stopSharing([entityEmail]);
    });
  }

  confirmAndStopSharingSelected(): void {
    this.commonMessagesService.showStopSharingRequestConfirmation(() => this.stopSharing(this.selected), true);
  }

  stopSharing(entityEmails: EntityEmail[]): void {
    this.sharedService.stopSharing(this.sharedResource.sharedResourceUuid, entityEmails).toPromise().then(response => {
      let deletedResource = response.deletedResource;
      if (deletedResource) {
        this.router.navigate(([`/shared`]), {state: {showView: 'sharedByUser'}});
      } else {
        this.loadSharedResource(this.sharedResource.sharedResourceUuid);
      }
      this.commonMessagesService.showSuccessfullyStopSharingMessage();
    }, error => {
      this.commonMessagesService.showErrorWhileSharingMessage();
    });
  }

  setSelectedEntityType(type: string): void {
    this.currentFilters.entityType = type;
  }

  applyFilters(): void {
    this.first = 0;
    this.table.filter(this.currentFilters.name?.trim(), 'name', 'contains');
    this.table.filter(this.currentFilters.entityType?.trim(), 'entityType', (this.currentFilters.entityType === null) ? 'isNot' : 'is');
    this.table.filter(this.currentFilters.email?.trim(), 'email', 'contains');
    this.table.filter(this.currentFilters.sharedBy?.trim(), 'sharedByUser', 'contains');
    this.filtersVisible = false;
  }

  resetFilters(): void {
    this.currentFilters = new EntityEmailFilters();
    this.applyFilters();
  }

  onFilter(event: any): void {
    this.totalSharedEmails = event.filteredValue.length;
  }
}
